import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromFermenter from 'app/state/fermenter';

export const fermenterDetailResolverFn: ResolveFn<any> = (route) => {
  const store = inject(Store);
  store.dispatch(fromFermenter.setItem({ id: route.params['id'] ?? '' }));
  return true;
};
